<template>
  <div v-cloak id="app">
    <header>
      <NavBar />
    </header>
    <main>
      <Messages />
      <router-view />
    </main>
  </div>
</template>
<script>
import NavBar from '@/components/NavBar.vue';
import Messages from '@/components/Messages.vue';
require('@/assets/app.css');
require('@/assets/all.css');
export default {
  components: { NavBar, Messages }
};
</script>
